import { Analytics, getScreenFromUrl } from '@trello/atlassian-analytics';
import { getChannel } from './getChannel';
import { getSessionId } from './getSessionId';
import { desktopVersion, clientVersion } from '@trello/config';
import { isBrowserSupported, isDesktop, browserStr } from '@trello/browser';
import { sendErrorEvent, SentryErrorMetadata } from './sendErrorEvent';

interface TracedError extends Error {
  traceId?: string;
}

interface CrashEventAttributes {
  trelloSessionId: string;
  channel: string | null;
  clientVersion: string | null;
  sentryEventId: string | null;
  isBrowserSupported: boolean;
  browser: string;
  isDesktop: boolean;
  desktopVersion: string;
  taskId?: string;
}

/**
 * Sends a crash metric (operational event) via our analytics client
 * and also sends the error along to our Sentry endpoint
 */
export const sendCrashEvent = async (
  error: TracedError,
  metadata: SentryErrorMetadata = {
    tags: {},
    extraData: {},
  },
) => {
  const channel = await getChannel();
  const source = getScreenFromUrl();

  // TODO: not this!
  //
  // See: https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
  //
  // We started seeing this error a few weeks ago, it's believed to be benign
  // but happens at a high frequency which results in alerts in web. We're
  // opting to mute it for now, because the usages of ResizeObserver are all in
  // 3rd-party dependencies
  if (error.message.includes('ResizeObserver loop limit exceeded')) {
    return;
  }

  const sentryEventId = sendErrorEvent(error, metadata);

  const attributes: CrashEventAttributes = {
    trelloSessionId: getSessionId(),
    channel,
    clientVersion,
    sentryEventId,
    isBrowserSupported: isBrowserSupported(),
    browser: browserStr,
    isDesktop: isDesktop(),
    desktopVersion: desktopVersion,
  };

  if (error.traceId) {
    attributes.taskId = error.traceId;
  }

  Analytics.sendOperationalEvent({
    source,
    action: 'crashed',
    actionSubject: 'app',
    attributes,
  });
};
